import { useHistory } from "react-router-dom";

const homologated = {
  condition: 'estado',
  type: 'tipo',
  conmune: 'comuna',
  bathrooms_quantity: 'baños',
  bedrooms_quantity: 'habitaciones',
  rental_fee_gte: 'precio_desde',
  rental_fee_lte: 'precio_hasta',
  total_area_gte: 'area_desde',
  total_area_lte: 'area_hasta',
  parking: 'estacionamiento',
  warehouse: 'bodega',
  furnished: 'amoblado',
  pageg: 'page',
}

const useParams = () => {
  const history = useHistory();

  const filterHomologation = (key, typePrice = null) => {
      return homologated[key]
  }

  function getKeyByValue(value) {
    return Object.keys(homologated).find(key => homologated[key] === value);
  }

  function filterToParams(filter) {
    if (filter !== undefined) {
      let params = new URLSearchParams(window.location.search)
      for (var pair of params.entries()) {
        params.delete(pair[0])
      }
      Object.keys(filter).map((key) => {
        if (filter[key] !== undefined) {
          if (filterHomologation(key)) {
            params.set(filterHomologation(key), filter[key])
          }
        }
        if (filter[key] === undefined) {
          params.delete(filterHomologation(key))
        }

        if (key === 'pageg' && filter[key] === 1) {
          params.delete(filterHomologation(key))
        }
      });
      return params
    }
  }

  const setParamsUrl = (filter) => {
    if (filter !== undefined) {
      let params = filterToParams(filter)
      history.push({ search: params.toString() })
    }
  }

  const setFiltersFromUrl = () => {
    const params = new URLSearchParams(window.location.search)
    let initialQueryState = {
      condition: undefined,
      type: undefined,
      conmune: undefined,
      bathrooms_quantity: undefined,
      bedrooms_quantity: undefined,
      rental_fee_gte: undefined,
      rental_fee_lte: undefined,
      total_area_gte: undefined,
      total_area_lte: undefined,
      pageg: undefined,
    };

    for (var param of params.entries()) {
      if (params.get(param[0]) !== '' && param[0] !== 'page') {
        initialQueryState = {
          ...initialQueryState, [getKeyByValue(param[0])]: param[1]
        }
      }

      if (params.get(param[0]) !== '' && param[0] === 'page') {
        let value = parseInt(param[1]) 
        initialQueryState = {
          ...initialQueryState, [getKeyByValue(param[0])]: isNaN(value)?1:value
        }
      }
    }
    return initialQueryState
  }

  const getParamsUrl = (filter) => {
    if (filter !== undefined) {
      return filterToParams(filter).toString()
    }
  }

  return [setParamsUrl, setFiltersFromUrl, getParamsUrl]
}

export default useParams
